import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  consultationForm: {
    name: '',
    email: '',
    company: '',
    projectType: '',
    budget: '',
    timeline: '',
    message: '',
  },
  contactForm: {
    name: '',
    email: '',
    subject: '',
    message: '',
  },
  isLoading: false,
  isSubmitted: false,
  error: null,
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    updateConsultationForm: (state, action) => {
      state.consultationForm = {
        ...state.consultationForm,
        ...action.payload,
      };
    },
    updateContactForm: (state, action) => {
      state.contactForm = {
        ...state.contactForm,
        ...action.payload,
      };
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setSubmitted: (state, action) => {
      state.isSubmitted = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetConsultationForm: (state) => {
      state.consultationForm = initialState.consultationForm;
      state.isSubmitted = false;
      state.error = null;
    },
    resetContactForm: (state) => {
      state.contactForm = initialState.contactForm;
      state.isSubmitted = false;
      state.error = null;
    },
  },
});

export const {
  updateConsultationForm,
  updateContactForm,
  setLoading,
  setSubmitted,
  setError,
  resetConsultationForm,
  resetContactForm,
} = formSlice.actions;

export const selectConsultationForm = (state) => state.form.consultationForm;
export const selectContactForm = (state) => state.form.contactForm;
export const selectFormLoading = (state) => state.form.isLoading;
export const selectFormSubmitted = (state) => state.form.isSubmitted;
export const selectFormError = (state) => state.form.error;

export default formSlice.reducer;